import { render, staticRenderFns } from "./Kpi.vue?vue&type=template&id=6f4df47b&scoped=true"
import script from "./Kpi.vue?vue&type=script&lang=js"
export * from "./Kpi.vue?vue&type=script&lang=js"
import style0 from "./Kpi.vue?vue&type=style&index=0&id=6f4df47b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4df47b",
  null
  
)

export default component.exports